import { COUNTRIES, COUNTRY_NAMES } from '@nv/react-commons/src/Constants'

export const mapCountriesToOptions = (countries: string[]) => {
  return countries.map((country: keyof typeof COUNTRIES) => ({
    value: country,
    text: COUNTRY_NAMES[country.toUpperCase()]
  }))
}

/**
 * Generates an option object for a given country string.
 * @param country - The country code string (e.g., 'SG', 'MY').
 * @returns An object with 'value' and 'text' properties for use in select fields.
 */
export const mapCountryToOption = (country: string) => {
  return {
    value: country.toUpperCase() as keyof typeof COUNTRIES,
    text: COUNTRY_NAMES[country.toUpperCase()]
  }
}
